module.exports = {"330482001":"当湖街道","330482002":"钟埭街道","330482003":"曹桥街道","330482101":"乍浦镇","330482102":"新埭镇","330482103":"新仓镇","330482106":"广陈镇","330482107":"林埭镇","330482108":"独山港镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330482.json
// module id = 984
// module chunks = 0